import { useMemo } from 'react';
import { useSelector } from '@grandvisionhq/state';
import { getAuth } from '../../selectors.js';
import { isUninitialized } from '../../state.js';

const useAvailableOptIns = ()=>{
    const auth = useSelector(getAuth);
    return useMemo(()=>({
            availableOptIns: !isUninitialized(auth) ? auth.optIns : []
        })
    , [
        auth
    ]);
};

export { useAvailableOptIns };
//# sourceMappingURL=use-available-opt-ins.js.map
